import { useEffect, useRef } from 'react';

const WasmApp = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        // Reset all default margins and paddings
        document.body.style.margin = '0';
        document.body.style.padding = '0';
        document.body.style.overflow = 'hidden';
        document.documentElement.style.margin = '0';
        document.documentElement.style.padding = '0';
        document.documentElement.style.overflow = 'hidden';
        
        async function initWasm() {
            try {
                const { default: init, start } = await import(/* webpackIgnore: true */ '/wasm_app/blocktime_wasm_web.js');
                await init();
                
                const canvas = canvasRef.current;
                if (!canvas) {
                    console.error('Canvas not found');
                    return;
                }
                
                await start(canvas);                
            } catch (error) {
                console.error('WASM initialization failed:', error);
            }
        }

        initWasm();
    }, []);

    return (
        <div 
            style={{
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                padding: '0',
                margin: '0',
                boxSizing: 'border-box',
                border: '5px solid #0957d0',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                backgroundColor: 'var(--main-bg-color, white)'
            }}
        >
            <div style={{
                flexGrow: 1,
                position: 'relative',
                overflow: 'hidden'
            }}>
                <canvas
                    ref={canvasRef}
                    id="rustCanvas"
                    style={{
                        width: '100%',
                        height: '100%',
                        display: 'block'
                    }}
                />
            </div>
            <div style={{
                padding: '10px 20px',
                borderTop: '1px solid #aaa',
                width: '100%',
                textAlign: 'center',
                backgroundColor: 'var(--main-bg-color, #1e1e1e)',
                boxSizing: 'border-box'
            }}>
                <a
                    href="https://twitter.com/intent/follow?screen_name=im0xPrince"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link"
                >
                    Built by @im0xPrince
                </a>
            </div>
        </div>
    );
};

export default WasmApp; 